import type { HTMLAttributes } from 'react';
import Image from 'next/image';

type LoadingLogoProps = {
  size?: 'compact' | 'default';
  className?: string;
};

/**
 * Scarlet Sync's shared progress mark. Loading states use the product logo so
 * route transitions stay quiet and recognizable.
 */
export function LoadingLogo({ size = 'default', className = '' }: LoadingLogoProps) {
  return (
    <span
      aria-hidden="true"
      className={`ss-loading-logo ${className}`}
      data-size={size}
    >
      <Image
        alt=""
        className="ss-loading-logo-image"
        sizes="80px"
        height={80}
        src="/logo/scarlet-sync-no-bg.png"
        width={80}
      />
    </span>
  );
}

/** @deprecated Use LoadingLogo. Kept temporarily for retained-content callers. */
export const LoadingBubbles = LoadingLogo;

export function PageLoading({
  title = 'Preparing your workspace',
  description,
  className = '',
  ...props
}: {
  title?: string;
  description?: string;
  className?: string;
} & Omit<HTMLAttributes<HTMLDivElement>, 'title'>) {
  return (
    <div
      {...props}
      aria-busy="true"
      aria-live="polite"
      className={`ss-page-loading ${className}`}
      role="status"
    >
      <LoadingLogo />
      <div className="ss-page-loading-copy">
        <p className="ss-page-loading-title">{title}</p>
        {description ? <p className="ss-page-loading-description">{description}</p> : null}
      </div>
    </div>
  );
}
